import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import useOutsideClickListener from '../../_shared/hooks/useOutsideClickListener';
import {
  OverlayTriggerWrapper,
  TriggeringElementWrapper,
  OverlayWrapper
} from './Styles';

const propTypes = {
  onRef: PropTypes.func,
  placement: PropTypes.oneOf(['right', 'bottom']).isRequired,
  children: PropTypes.element.isRequired, // the element which triggers the overlay to pop up
  overlay: PropTypes.element.isRequired,
  offset: PropTypes.shape({
    top: PropTypes.number,
    left: PropTypes.number
  }),
  style: PropTypes.object
};

const defaultProps = {
  onRef: undefined,
  offset: { top: 0, left: 0 },
  style: {}
};

const OverlayTrigger = ({
  onRef,
  placement,
  children,
  overlay,
  offset,
  style
}) => {
  const triggeringElementRef = useRef(null);
  const overlayRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const toggleOverlay = () => {
    setIsOpen(!isOpen);
  };
  const openOverlay = () => {
    setIsOpen(true);
  };
  const closeOverlay = () => {
    setIsOpen(false);
  };
  useEffect(() => {
    if (onRef) {
      onRef(closeOverlay);
    }
  }, [onRef]);
  useOutsideClickListener(overlayRef, closeOverlay, true, triggeringElementRef);
  const calculateTop = () => {
    let { top } = offset;
    if (isOpen && placement === 'bottom') {
      top += triggeringElementRef.current.offsetHeight;
    }
    return `${top}px`;
  };
  const calculateLeft = () => {
    let { left } = offset;
    if (isOpen && placement === 'right') {
      left += triggeringElementRef.current.offsetWidth;
    }
    return `${left}px`;
  };

  return (
    <OverlayTriggerWrapper style={style}>
      <TriggeringElementWrapper
        ref={triggeringElementRef}
        onClick={toggleOverlay}
        onKeyDown={openOverlay}
      >
        {children}
      </TriggeringElementWrapper>
      {isOpen && (
        <OverlayWrapper
          ref={overlayRef}
          top={calculateTop()}
          left={calculateLeft()}
        >
          {overlay}
        </OverlayWrapper>
      )}
    </OverlayTriggerWrapper>
  );
};
OverlayTrigger.propTypes = propTypes;
OverlayTrigger.defaultProps = defaultProps;
export default OverlayTrigger;
